import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import { AunthLogin } from './views/authentification/content';
import { TextProvider } from "./TextProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <TextProvider>
    <App />
  </TextProvider>
);

reportWebVitals();
